import { gql } from 'apollo-angular';

export const CATALOG_PURCHASED_PRODUCTS = gql`
  query MeasurementGetPurchasedProducts($buyerId: Long!, $contextIds: [Long]) {
    purchasedProducts(
      buyerId: $buyerId
      criteria: { contextName: "ALL_PRODUCTS", contextIds: $contextIds }
    ) {
      id
      erpProductId
    }
  }
`;
